/* ============================================
   Boba Japan Theme — JavaScript
   ============================================ */

(function() {
  'use strict';

  /* --- Announcement bar + Header offset --- */
  const header = document.querySelector('[data-header]');
  const announcementBar = document.querySelector('.announcement-bar');

  function updateHeaderOffset() {
    if (header && announcementBar) {
      var abHeight = announcementBar.offsetHeight;
      var scrolled = window.scrollY >= abHeight;
      header.style.top = scrolled ? '0' : abHeight - window.scrollY + 'px';
    }
  }

  /* --- Transparent Header scroll behavior --- */
  if (header && header.classList.contains('header--transparent')) {
    window.addEventListener('scroll', function() {
      var threshold = announcementBar ? announcementBar.offsetHeight + 80 : 80;
      if (window.scrollY > threshold) {
        header.classList.add('header--scrolled');
      } else {
        header.classList.remove('header--scrolled');
      }
      updateHeaderOffset();
    });
    updateHeaderOffset();
  }

  /* --- Mega Menu --- */
  const megaMenuTrigger = document.querySelector('[data-mega-menu-trigger]');
  const megaMenu = document.querySelector('[data-mega-menu]');

  if (megaMenuTrigger && megaMenu) {
    var megaMenuTimeout;
    megaMenuTrigger.addEventListener('mouseenter', function() {
      clearTimeout(megaMenuTimeout);
      megaMenu.classList.add('is-active');
    });
    megaMenuTrigger.addEventListener('mouseleave', function() {
      megaMenuTimeout = setTimeout(function() {
        megaMenu.classList.remove('is-active');
      }, 200);
    });
    megaMenu.addEventListener('mouseenter', function() {
      clearTimeout(megaMenuTimeout);
    });
    megaMenu.addEventListener('mouseleave', function() {
      megaMenu.classList.remove('is-active');
    });
    // Close when clicking outside
    document.addEventListener('click', function(e) {
      if (!megaMenuTrigger.contains(e.target) && !megaMenu.contains(e.target)) {
        megaMenu.classList.remove('is-active');
      }
    });
  }

  /* --- Mobile Menu --- */
  const mobileNav = document.querySelector('[data-mobile-nav]');
  const mobileMenuOpen = document.querySelector('[data-mobile-menu-open]');
  const mobileMenuClose = document.querySelector('[data-mobile-menu-close]');
  const cartBackdrop = document.querySelector('[data-cart-backdrop]');

  if (mobileMenuOpen && mobileNav) {
    mobileMenuOpen.addEventListener('click', function() {
      mobileNav.classList.add('is-open');
      if (cartBackdrop) cartBackdrop.classList.add('is-open');
      document.body.style.overflow = 'hidden';
    });
  }
  if (mobileMenuClose && mobileNav) {
    mobileMenuClose.addEventListener('click', closeMobileMenu);
  }
  if (cartBackdrop) {
    cartBackdrop.addEventListener('click', function() {
      closeMobileMenu();
      closeCartDrawer();
    });
  }

  function closeMobileMenu() {
    if (mobileNav) mobileNav.classList.remove('is-open');
    if (cartBackdrop) cartBackdrop.classList.remove('is-open');
    document.body.style.overflow = '';
  }

  /* --- Cart Drawer --- */
  const cartToggle = document.querySelector('[data-cart-toggle]');
  const cartDrawer = document.querySelector('[data-cart-drawer]');

  if (cartToggle) {
    cartToggle.addEventListener('click', function(e) {
      e.preventDefault();
      // For now, redirect to cart page
      window.location.href = '/cart';
    });
  }

  function closeCartDrawer() {
    if (cartDrawer) cartDrawer.classList.remove('is-open');
    if (cartBackdrop) cartBackdrop.classList.remove('is-open');
    document.body.style.overflow = '';
  }

  /* --- Product Tabs --- */
  const tabButtons = document.querySelectorAll('[data-tab]');
  tabButtons.forEach(function(btn) {
    btn.addEventListener('click', function() {
      const tabId = this.getAttribute('data-tab');
      // Deactivate all
      document.querySelectorAll('.tab-button').forEach(function(b) { b.classList.remove('is-active'); });
      document.querySelectorAll('.tab-panel').forEach(function(p) { p.classList.remove('is-active'); });
      // Activate selected
      this.classList.add('is-active');
      var panel = document.querySelector('[data-tab-panel="' + tabId + '"]');
      if (panel) panel.classList.add('is-active');
    });
  });

  /* --- Product Gallery Thumbnails --- */
  const thumbs = document.querySelectorAll('[data-thumb]');
  const mainImg = document.getElementById('product-main-img');
  thumbs.forEach(function(thumb) {
    thumb.addEventListener('click', function() {
      thumbs.forEach(function(t) { t.classList.remove('is-active'); });
      this.classList.add('is-active');
      if (mainImg) {
        mainImg.src = this.getAttribute('data-image-url');
      }
    });
  });

  /* --- Quantity +/- buttons --- */
  const qtyMinus = document.querySelector('[data-qty-minus]');
  const qtyPlus = document.querySelector('[data-qty-plus]');
  const qtyInput = document.querySelector('[data-qty-input]');

  if (qtyMinus && qtyPlus && qtyInput) {
    qtyMinus.addEventListener('click', function() {
      var val = parseInt(qtyInput.value, 10) || 1;
      if (val > 1) qtyInput.value = val - 1;
    });
    qtyPlus.addEventListener('click', function() {
      var val = parseInt(qtyInput.value, 10) || 1;
      qtyInput.value = val + 1;
    });
  }

  /* --- Variant swatch selection --- */
  const optionInputs = document.querySelectorAll('[data-option-index]');
  const variantSelect = document.querySelector('[data-product-variant]');
  const priceDisplay = document.querySelector('[data-product-price]');
  const atcButton = document.querySelector('.product-info__atc');

  if (optionInputs.length > 0 && variantSelect) {
    optionInputs.forEach(function(input) {
      input.addEventListener('change', function() {
        // Update swatch active state
        var parent = this.closest('.product-info__option-values');
        if (parent) {
          parent.querySelectorAll('.product-info__swatch').forEach(function(s) {
            s.classList.remove('is-active');
          });
          this.closest('.product-info__swatch').classList.add('is-active');
        }

        // Build selected options array
        var selectedOptions = [];
        document.querySelectorAll('.product-info__option').forEach(function(optionGroup) {
          var checked = optionGroup.querySelector('input[type="radio"]:checked');
          if (checked) selectedOptions.push(checked.value);
        });

        // Find matching variant
        var options = variantSelect.options;
        for (var i = 0; i < options.length; i++) {
          var optionTitle = options[i].textContent.trim();
          var match = selectedOptions.every(function(val) {
            return optionTitle.indexOf(val) !== -1;
          });
          if (match) {
            variantSelect.selectedIndex = i;
            // Update price
            if (priceDisplay && options[i].dataset.price) {
              var taxSpan = priceDisplay.querySelector('.product-info__tax');
              var taxHtml = taxSpan ? taxSpan.outerHTML : '';
              priceDisplay.innerHTML = options[i].dataset.price + '\n          ' + taxHtml;
            }
            // Update availability
            if (atcButton) {
              if (options[i].disabled) {
                atcButton.disabled = true;
                atcButton.textContent = '売り切れ';
              } else {
                atcButton.disabled = false;
                atcButton.textContent = 'カートに入れる';
              }
            }
            // Update URL
            if (history.replaceState) {
              var url = window.location.pathname + '?variant=' + options[i].value;
              history.replaceState({}, '', url);
            }
            break;
          }
        }
      });
    });
  }

  /* --- Smooth scroll for anchor links --- */
  document.querySelectorAll('a[href^="#"]').forEach(function(anchor) {
    anchor.addEventListener('click', function(e) {
      var target = document.querySelector(this.getAttribute('href'));
      if (target) {
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
  });

})();
